import React from 'react';
import { LineItem } from '@pperform/pp-data-mappers';
import Shipment from 'interfaces/PmParcel';
import LoadingDots from 'components/LoadingDots';
import { useTranslation } from 'react-i18next';
import { useOrderLineItems } from './hooks';
import { GroupLabel, LoadingContainer } from './OrderLineItems.styles';

interface OrderLineItemsProps {
  orderId: string;
  shipment: Shipment;
}

const OrderLineItems: React.FC<OrderLineItemsProps> = ({
  orderId,
  shipment,
  children,
}) => {
  const { t } = useTranslation();
  const { loading, orderLineItems } = useOrderLineItems(orderId, shipment);

  const renderChildren = (lineItems: LineItem[]) => {
    return React.Children.map(children, (child) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, {
          shipmentLineItems: lineItems || [],
        } as any);
      }
      return child;
    });
  };

  if (loading) {
    return (
      <LoadingContainer data-testid="order-line-items-loading">
        <LoadingDots />
      </LoadingContainer>
    );
  }

  return (
    <>
      {renderChildren(shipment.lineItems)}
      {orderLineItems.map(({ lineItems, trackingNumber }) => {
        return (
          <>
            <GroupLabel data-testid="group-label">
              {t('RETURN_ORDER_LEVEL_QUESTION', { trackingNumber })}
            </GroupLabel>
            {renderChildren(lineItems)}
          </>
        );
      })}
    </>
  );
};

export { OrderLineItems };
